import React from 'react'

export const Students = [
  {
    name: 'list',
    component: React.lazy(() => import('../../modules/common/UsersList')),
    path: '/coordinator/students',
    guards: ['allowOnlyCoordinator', 'allowOnlyLogged', 'allowStudentsList'],
  },
  {
    name: 'edit',
    component: React.lazy(() => import('../../modules/coordinator/students/editStudent')),
    path: '/coordinator/students/edit/:studentId',
    guards: ['allowOnlyCoordinator', 'allowOnlyLogged'],
  },
]
